import { TopicoHotleads } from './TopicoHotleads';
import { TopicoLembreteAtividade } from './TopicoLembreteAtividade';

export const TOPICOS = new Map();
TOPICOS.set('LEMBRETE_ATIVIDADES_APP', TopicoLembreteAtividade);
TOPICOS.set('HOTLEADS', TopicoHotleads);
